// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Y70PwTNx {
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  outline: none;
  font-family: inherit;
  min-height: 2.75rem;
  min-width: 2.75rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
          justify-content: center;
  gap: 0.25rem;
  border-radius: 0.5rem;
  font-weight: 500;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  cursor: pointer;
  position: relative;
}
.Y70PwTNx:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.Y70PwTNx.NQwwGnAq {
  width: 100%;
}
.Y70PwTNx.OQZUtOGY {
  pointer-events: none;
}
.Qz7UeL5c {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  min-height: 2rem;
}
.OV4eDB8s {
  padding: 0.5rem 1rem;
  font-size: 1rem;
  min-height: 2.5rem;
}
.qCyFMUyu {
  padding: 1rem 1.5rem;
  font-size: 1.125rem;
  min-height: 3rem;
}
.CnTG51_0 {
  background: #1890ff;
  color: #ffffff;
}
.CnTG51_0:hover:not(:disabled) {
  opacity: 0.9;
}
.CnTG51_0:active:not(:disabled) {
  opacity: 0.8;
}
.V1aFxtp8 {
  background: #666666;
  color: #ffffff;
}
.V1aFxtp8:hover:not(:disabled) {
  opacity: 0.9;
}
.vMTVucZw {
  background: transparent;
  color: #1890ff;
  border: 1px solid #1890ff;
}
.vMTVucZw:hover:not(:disabled) {
  background: #1890ff;
  color: #ffffff;
}
.I8Zq9TzC {
  background: transparent;
  color: #1890ff;
}
.I8Zq9TzC:hover:not(:disabled) {
  background: rgba(24, 144, 255, 0.1);
}
.BbmB6pw2 {
  width: 1rem;
  height: 1rem;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: #ffffff;
  border-radius: 50%;
  -webkit-animation: nlyS_Ag3 0.6s linear infinite;
          animation: nlyS_Ag3 0.6s linear infinite;
}
@-webkit-keyframes nlyS_Ag3 {
  to {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
@keyframes nlyS_Ag3 {
  to {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Button/Button.module.less","webpack://./src/styles/mixins.less"],"names":[],"mappings":"AAGA;ECqGE,YAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EAEA,aAAA;EACA,oBAAA;EAKA,mBAAA;EACA,kBAAA;EAvDA,oBAAA;EAAA,qBAAA;EAAA,aAAA;EACA,yBAAA;EAAA,2BAAA;UAAA,mBAAA;EACA,wBAAA;EAAA,+BAAA;UAAA,uBAAA;EDxDA,YAAA;EACA,qBAAA;EACA,gBAAA;EACA,iCAAA;EAAA,yBAAA;EACA,eAAA;EACA,kBAAA;AAMF;AAJE;EACE,YAAA;EACA,mBAAA;AAMJ;AAHE;EACE,WAAA;AAKJ;AAFE;EACE,oBAAA;AAIJ;AACA;EACE,uBAAA;EACA,mBAAA;EACA,gBAAA;AACF;AAEA;EACE,oBAAA;EACA,eAAA;EACA,kBAAA;AAAF;AAGA;EACE,oBAAA;EACA,mBAAA;EACA,gBAAA;AADF;AAKA;EACE,mBAAA;EACA,cAAA;AAHF;AAKE;EACE,YAAA;AAHJ;AAME;EACE,YAAA;AAJJ;AAQA;EACE,mBAAA;EACA,cAAA;AANF;AAQE;EACE,YAAA;AANJ;AAUA;EACE,uBAAA;EACA,cAAA;EACA,yBAAA;AARF;AAUE;EACE,mBAAA;EACA,cAAA;AARJ;AAYA;EACE,uBAAA;EACA,cAAA;AAVF;AAYE;EACE,mCAAA;AAVJ;AAcA;EACE,WAAA;EACA,YAAA;EACA,0CAAA;EACA,yBAAA;EACA,kBAAA;EACA,gDAAA;UAAA,wCAAA;AAZF;AAeA;EACE;IACE,iCAAA;YAAA,yBAAA;EAbF;AACF;AAUA;EACE;IACE,iCAAA;YAAA,yBAAA;EAbF;AACF","sourcesContent":["@import '@/styles/variables.less';\n@import '@/styles/mixins.less';\n\n.button {\n  .button-reset();\n  .touch-friendly();\n  .flex-center();\n  gap: @spacing-xs;\n  border-radius: @border-radius-md;\n  font-weight: 500;\n  transition: @transition-base;\n  cursor: pointer;\n  position: relative;\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n\n  &.fullWidth {\n    width: 100%;\n  }\n\n  &.loading {\n    pointer-events: none;\n  }\n}\n\n// 尺寸\n.small {\n  padding: @spacing-xs @spacing-sm;\n  font-size: @font-size-sm;\n  min-height: 2rem; // 32px\n}\n\n.medium {\n  padding: @spacing-sm @spacing-md;\n  font-size: @font-size-md;\n  min-height: 2.5rem; // 40px\n}\n\n.large {\n  padding: @spacing-md @spacing-lg;\n  font-size: @font-size-lg;\n  min-height: 3rem; // 48px\n}\n\n// 变体\n.primary {\n  background: @primary-color;\n  color: @white;\n\n  &:hover:not(:disabled) {\n    opacity: 0.9;\n  }\n\n  &:active:not(:disabled) {\n    opacity: 0.8;\n  }\n}\n\n.secondary {\n  background: @text-color-secondary;\n  color: @white;\n\n  &:hover:not(:disabled) {\n    opacity: 0.9;\n  }\n}\n\n.outline {\n  background: transparent;\n  color: @primary-color;\n  border: 1px solid @primary-color;\n\n  &:hover:not(:disabled) {\n    background: @primary-color;\n    color: @white;\n  }\n}\n\n.text {\n  background: transparent;\n  color: @primary-color;\n\n  &:hover:not(:disabled) {\n    background: rgba(@primary-color, 0.1);\n  }\n}\n\n.spinner {\n  width: 1rem; // 16px\n  height: 1rem; // 16px\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-top-color: @white;\n  border-radius: 50%;\n  animation: spin 0.6s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n","@import './variables.less';\n\n// 响应式 Mixins\n.mobile(@rules) {\n  @media (max-width: 767px) {\n    @rules();\n  }\n}\n\n.mobileNarrow(@rules) {\n  @media (max-width: 413px) {\n    @rules();\n  }\n}\n\n.tablet(@rules) {\n  @media (min-width: 768px) and (max-width: 1023px) {\n    @rules();\n  }\n}\n\n.desktop(@rules) {\n  @media (min-width: 1024px) {\n    @rules();\n  }\n}\n\n.tablet-up(@rules) {\n  @media (min-width: 768px) {\n    @rules();\n  }\n}\n\n// 紧凑 PC（1024~1728 宽）：首页 banner 缩小与垂直微调\n.homeCompactPc(@rules) {\n  @media (min-width: 1024px) and (max-width: 1728px) {\n    @rules();\n  }\n}\n\n.homeCompactPcShort(@rules) {\n  @media (min-width: 1024px) and (max-width: 1728px) and (max-height: 1000px) {\n    @rules();\n  }\n}\n\n// 宽屏 PC（>1728 宽）：首页 banner 放大\n.homeWidePc(@rules) {\n  @media (min-width: 1729px) {\n    @rules();\n  }\n}\n\n// 浏览器放大/缩小时：横向裁切装饰溢出，纵向允许滚动避免内容显示不全\n.zoomScrollablePage() {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n// Flexbox Mixins\n.flex-center() {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.flex-between() {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.flex-start() {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n// 文本省略\n.text-ellipsis() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.text-ellipsis-multi(@lines: 2) {\n  display: -webkit-box;\n  -webkit-line-clamp: @lines;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n// 清除浮动\n.clearfix() {\n  &::after {\n    content: '';\n    display: table;\n    clear: both;\n  }\n}\n\n// 按钮重置\n.button-reset() {\n  border: none;\n  background: none;\n  padding: 0;\n  margin: 0;\n  cursor: pointer;\n  outline: none;\n  font-family: inherit;\n}\n\n// 触摸友好\n.touch-friendly() {\n  min-height: 2.75rem; // 44px\n  min-width: 2.75rem; // 44px\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `Y70PwTNx`,
	"fullWidth": `NQwwGnAq`,
	"loading": `OQZUtOGY`,
	"small": `Qz7UeL5c`,
	"medium": `OV4eDB8s`,
	"large": `qCyFMUyu`,
	"primary": `CnTG51_0`,
	"secondary": `V1aFxtp8`,
	"outline": `vMTVucZw`,
	"text": `I8Zq9TzC`,
	"spinner": `BbmB6pw2`,
	"spin": `nlyS_Ag3`
};
export default ___CSS_LOADER_EXPORT___;
